import utils from '@/utils';

// 导入modules文件夹下面所有文件
const moduleFiles = require.context('./modules', true, /\.js$/);

// 解析导入的文件
const api = utils.resolveRequire(moduleFiles, ['Service']);
export default api;
